import { type NodeSpec } from "prosemirror-model";

// :: NodeSpec The text node.

export const text: NodeSpec = {
	group: "inline",
};
